/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'TablaImpresion.Acciones': 'Actions ',
    'TablaImpresion.TablaImpresion': 'Brands',
    'TablaImpresion.NombreEtiqueta': '',
    'TablaImpresion.PapelTamano': 'Paper size',
    'TablaImpresion.Pallet': 'Its Pallet',
    'TablaImpresion.CodigoInterno': 'Internal code',
    'TablaImpresion.CodigoEmpresaItem': 'Company code',
    'TablaImpresion.Producto': 'Product',
    'TablaImpresion.Unidad': 'Unit',
    'TablaImpresion.Lote': 'Batch',
    'TablaImpresion.Serial': 'Serial',
    'TablaImpresion.Filtros': 'Filters',
    'TablaImpresion.Etiqueta': 'Hashtag ',
    'TablaImpresion.SerialInicio': 'Serial start',
    'TablaImpresion.SerialFin': 'Serial end ',
    'TablaImpresion.Impresora': 'Printing machine',
    'TablaImpresion.NumeroCopias': 'Number of copies',
    'TablaImpresion.EsPallet': 'Is pallet',
    'boton.Imprimir': 'Print',
    'boton.Buscar': 'Search',
    'boton.Limpiar': 'Clean',
    'TablaImpresion.Imprimir': 'Print',
    'TablaImpresion.FechaIngreso': 'Admission date',
    'TablaImpresion.FechaVencimiento': 'Expiration date',
    'boton.AbrirFoemularioItemEtiqueta': 'Administrar item',
    'TablaImpresion.CantidadPallet': 'Quantity pallet',
    'TablaImpresion.ConfirmacionImpresion': 'Are you sure you want to print the selected products?',
    'sidebar.impresion': 'Impression',
    'TablaEtiquetaItems.ConfirmacionProductoEtiqueta':
        'Are you sure you want to associate the selected products to the label',
    'TablaEtiquetaItems.RequeridosProductoEtiqueta': 'You must select products to add to the label',
};
